/**
 * i18n Grundkonfiguration.
 *
 * DEFAULT_LOCALE ist die Sprache, die ein Benutzer sieht, wenn er noch nie
 * eine Sprache gewählt hat. Sie hier zu ändern ändert die Produktvorgabe —
 * es ist bewusst eine einzige Konstante.
 */
export const DEFAULT_LOCALE = 'de';

/**
 * Browsersprache automatisch übernehmen, wenn der Benutzer noch nichts gewählt hat?
 * Bewusst AUS: bestehende Benutzer sollen weiterhin Deutsch sehen.
 * Auf true setzen, sobald die automatische Erkennung gewünscht ist.
 */
export const AUTO_DETECT_LOCALE = false;

/** localStorage-Schlüssel der Sprachwahl. */
export const LOCALE_STORAGE_KEY = 'vyndesk.locale';
